import { render, staticRenderFns } from "./EditOutOfOffice.vue?vue&type=template&id=72ecb6e7&"
import script from "./EditOutOfOffice.vue?vue&type=script&lang=js&"
export * from "./EditOutOfOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports